import {
  IReleaseDTO,
  IReleaseTypeDTO,
  ITeamCriteriaSelectionDTO,
  ITeamDTO,
  IUserDTO,
} from '@/dtos';
import { get, post } from '@/services/apiWrapper';

export const getMyTeamForThisYearAPI = async (yearId: string) => {
  let param = '';
  if (yearId) {
    param = `?year=${yearId}`;
  }
  const team = await get(`/teams/getMyTeamForThisYear${param}`);
  return team;
};

export const getMyCriteriaAPI = async (
  yearId: string,
  teamId: string,
): Promise<{ data: ITeamCriteriaSelectionDTO[]; count: number }> => {
  const critera = await get<{ data: ITeamCriteriaSelectionDTO[]; count: number }>(
    `/team/${teamId}/year/${yearId}/criteria`,
  );
  return critera;
};

export const getMyTeamAPI = async (): Promise<ITeamDTO> => {
  const team = await get<ITeamDTO>(`/teams/getMyTeam`);
  return team;
};

export const checkIfTeamExistsAPI = async (teamName: string, teamId?: string): Promise<boolean> => {
  const crit = await post<boolean>(`/teams/checkname`, { teamName: teamName, teamId: teamId });
  return crit;
};

export const removeOptionalCriteriaAPI = async (critId: string): Promise<boolean> => {
  const crit = await post<boolean>(`/teams/removeOptionalCritieria`, { critId: critId });
  return crit;
};

export const addOptionalCriteriaAPI = async (critIds: string[]): Promise<boolean> => {
  const crit = await post<boolean>(`/teams/saveOptionalCritieria`, { critIds: critIds });
  return crit;
};

export const saveCriteriaSelectionUseAPI = async (
  criteriaSelection: ITeamCriteriaSelectionDTO,
): Promise<boolean> => {
  const crit = await post<boolean>(`/teams/teamCriteria/use`, criteriaSelection);
  return crit;
};

export const updateMyTeamAPI = async (team: ITeamDTO): Promise<ITeamDTO> => {
  const updated = await post<ITeamDTO>(`/teams/updateMyTeam`, team);
  return updated;
};

export const getMyContestsAPI = async (yearId: string) => {
  let param = '';
  if (yearId) {
    param = `?year=${yearId}`;
  }
  const updated = await get(`/teams/contests${param}`);
  return updated;
};

export const getReleaseTypesAPI = async (): Promise<{ data: IReleaseTypeDTO[]; count: number }> => {
  const types = await get<{ data: IReleaseTypeDTO[]; count: number }>(`/release/types`);
  return types;
};

export const getSubmissionReleasesAPI = async (
  submissionId: string,
): Promise<{ data: IReleaseDTO[]; count: number }> => {
  const types = await get<{ data: IReleaseDTO[]; count: number }>(
    `/team/submission/${submissionId}/releases`,
  );
  return types;
};

export const updateReleaseDonesAPI = async (submissionId: string, value: boolean) => {
  const types = await post(`/team/submission/${submissionId}/currentReleaseDone`, { value: value });
  return types;
};

export const userCreateNewTeamAPI = async (body: ITeamDTO) => {
  const result = await post(`/teams/createNew`, body);
  return result;
};

export const getTeamLeadIdAPI = async (teamId: string, yearId?: string): Promise<IUserDTO> => {
  const user = await get<IUserDTO>(`/teams/${teamId}/leader/${yearId}`);
  return user;
};
